import { onCLS, onFCP, onLCP, onTTFB,onINP } from "web-vitals";
import { lazyReportCache } from "../report/index.js";

export default function performance() {
  onCLS(sendToAnalytics);
  onINP(sendToAnalytics);
  onLCP(sendToAnalytics);
  onFCP(sendToAnalytics);
  onTTFB(sendToAnalytics);
}

function sendToAnalytics(metric) {
  const data = {
    name: metric.name,
    value: metric.value,
    // rating: metric.rating,
  }
  lazyReportCache('performance', data);
}

